<template>
  <!--begin::Basic info-->
  <div class="card mb-5 mb-xl-10">
    <!--begin::Content-->
    <EditHargaFitur></EditHargaFitur>
    <!--end::Content-->
  </div>
</template>
<script>
import EditHargaFitur from "@/components/1crm/fitur/management-harga/edit.vue";
import { defineComponent, onMounted } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "add-pricing",
  components: {
    EditHargaFitur,
  },
  setup() {
    const store = useStore();

    onMounted(() => {
      store.dispatch(Actions.VERIFY_AUTH_SEKOLAH);
      setCurrentPageBreadcrumbs("Edit Master Fitur", ["Management Fitur", "Master Fitur"]);
    });
  },
});
</script>
